<template>
  <div class="col-12 home-bonuses-container px-0 mb-3">

  </div>
</template>

<script>
export default {
  name: 'HomeBonuses',
  computed: {
    // bonusList () {
    //   let bonuses = this.$store.getters['getActiveBonuses'];
    //   if (!bonuses) {
    //     this.$store.dispatch('fetchActiveBonuses')
    //   }
    //   return this.$store.getters['getActiveBonuses']
    // }
  },
  methods: {
    getIcon (icon) {
      console.log(icon)
      return ''
    }
  }
}
</script>

